export default {
  disasterAvoidPolygons: {
    name: 'Név',
    description: 'Leírás',
    disasterType: 'Katasztrófa típusa',
    disasterSubType: 'Katasztrófa altípus',
    fillRequiredFields: 'Kérjük, töltse ki a katasztrófa területéhez szükséges mezőket',
    avoidAreaSaved: 'Katasztrófa sújtotta terület mentve',
    avoidAreaDeleted: 'Katasztrófa terület törölve',
    fillAreaProperties: 'Töltse ki az elkerülő terület tulajdonságait, és mentse el',
    editProperties: 'Tulajdonságok szerkesztése',
    createADisasterPolygon: 'Hozzon létre egy katasztrófa sokszöget',
    createADisasterRectangle: 'Create a disaster rectangle',
    errorWhileTryingToSaveDisasterArea: 'Hiba történt a katasztrófa sújtotta terület mentése közben',
    authorizationError: 'Engedélyezési hiba. Kérjük, ellenőrizze, hogy a megadott kulcs érvényes-e. A kulcs újbóli megadásához töltse be újra az alkalmazást',
    disasterAreaUsageInfo: 'A következőket teheti: a térképnézet mozgatásával betöltheti a megcélzott régió katasztrófa területeit, a sokszögrajzoló eszközökkel új katasztrófa területeket hozhat létre, és a katasztrófa területére kattintva szerkesztheti azt',
    errorCodes: {
      2404: 'Szolgáltató nem létezik',
      3404: 'Katasztrófa típus nem létezik',
      5409: 'A katasztrófaterület neve már használatban van'
    },
    statuses: {
      401: 'Jogosulatlan',
    }
  }
}
